// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__z6O9l","dragIcon":"SortableItem_dragIcon__19iX5","disabled":"SortableItem_disabled__LLnRY"};